// Get the container
const slideContainer = document.querySelector(".slide_container");

// URLs for desktop images
const desktopImageUrls = [
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/1_b56273e1-8695-4e33-8adc-83f3a8a75192.gif?v=1729686309",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/2_ed8a0c70-2f3f-4367-bc8b-886a3ad25238.gif?v=1729686309",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/3_056016e7-93ac-4722-8135-0a6610278660.gif?v=1729686310",
];

// URLs for mobile images
const mobileImageUrls = [
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/10.26Mobile1.gif?v=1729686616",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/2_3539d65d-e38c-4f1e-8e9d-0bf6f8a66a94.png?v=1729686450",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/4_66b76755-ae69-43c6-b0a0-d1884008f6e0.png?v=1729686451",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/5_8cfed3b5-362a-465b-adf9-3f1f67d1dc29.png?v=1729686452",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/6_02f4a82f-eef6-4f86-862a-ad80286c5fe6.png?v=1729686453",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/7_b4d59710-836b-428e-8775-b89aa076fa3a.png?v=1729686453",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/8_26d27f55-5d37-4144-a96b-ca9e7326ea90.png?v=1729686453",
  "https://cdn.shopify.com/s/files/1/0641/0023/7487/files/9_16599e94-9380-4253-98b0-b648a8b39722.png?v=1729686451",
];

// Function to determine screen size and load appropriate images
function loadImages() {
  const isMobile = window.innerWidth <= 768;

  // Clear the container
  slideContainer.innerHTML = "";

  if (isMobile) {
    // Create and append mobile images
    mobileImageUrls.forEach((url) => {
      const mobileImage = document.createElement("img");
      mobileImage.src = url;
      mobileImage.alt = "Mobile image";
      mobileImage.className = "mobile-image";
      slideContainer.appendChild(mobileImage);
    });
  } else {
    // Create and append desktop images
    desktopImageUrls.forEach((url) => {
      const desktopImage = document.createElement("img");
      desktopImage.src = url;
      desktopImage.alt = "Desktop image";
      desktopImage.className = "desktop-image";
      slideContainer.appendChild(desktopImage);
    });
  }
}

// Call the function initially
loadImages();

// Listen for window resize events to update images if necessary
window.addEventListener("resize", loadImages);

document.addEventListener("DOMContentLoaded", function () {
  // Set the target end time (June 6, 2024, at 11:00 AM ET)
  const targetEndTime = new Date("2024-06-06T11:00:00-04:00").getTime();

  function updateCountdown() {
    const currentTime = new Date().getTime();
    const timeDifference = targetEndTime - currentTime;

    // Check if the countdown has ended
    if (timeDifference <= 0) {
      document.getElementById("countdown").textContent = "Ready!";
      return;
    }

    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    document.getElementById("countdown").textContent = `${String(
      hours
    ).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(
      seconds
    ).padStart(2, "0")}`;

    setTimeout(updateCountdown, 1000);
  }

  updateCountdown();
});
